export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "category": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("name")), " : ", _interpolate(_named("count")), " ventes (", _interpolate(_named("share")), " %)"])}
      },
      "en": {
        "category": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("name")), ": ", _interpolate(_named("count")), " sales (", _interpolate(_named("share")), "%)"])}
      }
    }
  })
}
